export class WorkflowUserProfile {
    public id: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public password: string;
    public group: string;
}
